import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { Dispatch, SetStateAction, useState } from 'react'
import useMarkAsWinnerRaffle from '../hooks/useMarkAsWinnerRaffle'
import { useQueryClient } from '@tanstack/react-query'

interface MarkAsWinnerRaffleModalProps {
  raffleId?: string
  rewardTicketId?: string
  setIsError: Dispatch<SetStateAction<boolean>>
  setMessages: Dispatch<SetStateAction<boolean | string[]>>
}

export const MarkAsWinnerRaffleModal = ({ 
  raffleId,
  rewardTicketId,
  setIsError,
  setMessages,
 }: MarkAsWinnerRaffleModalProps) => {
  const queryClient = useQueryClient()

  const [isOpen, setIsOpen] = useState(false)

  const { mutate: markAsWinner, isPending: markAsWinnerIsPending } = useMarkAsWinnerRaffle({
    id: rewardTicketId,
    onSuccess: () => {
      setIsOpen(false)
      queryClient.invalidateQueries({ queryKey: ['tmaisRaffle', raffleId] })
      queryClient.invalidateQueries({ queryKey: ['rewardTickets'] })
      setMessages(['Ticket aprovado com sucesso!'])
    },
    onError: (error) => {
      if (error.response?.data.errors.base) {
        setIsError(true)
        setMessages(error.response?.data.errors.base)
      }
    }
  })

  return (
    <Modal
      Trigger={        
        <Button 
          variant='success'
          operationKlassToCheckPermission='Admin::Tmais::RewardTickets::MarkAsWinner'
        >
          Aprovar vencedor
        </Button>
      }
      title="Confirmar aprovação do vencedor"
      subtitle="Você tem certeza?"
      subtitleClassName="mt-1 text-white-300"
      useCancellableFooter
      confirmButtonText='Aprovar'
      disabled={markAsWinnerIsPending}
      confirmButtonIsLoading={markAsWinnerIsPending}
      confirmButtonClassName='bg-primary-blue hover:bg-primary-blue-hover disabled:opacity-50 disabled:hover:bg-primary-blue'
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onConfirm={markAsWinner}
    />
  )
}
